<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_rewards', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex justify-end">
            <AppButton element="InertiaLink" :href="meta.links.requests_index">
                {{ $t('messages.pending_requests') }}: {{ meta.info.pendingRequests }}
            </AppButton>
        </div>

        <AppWell class="mt-3">
            <div class="md:grid md:grid-cols-5 md:gap-6">
                <div class="p-1" v-for="(gamification_reward, index) in rewards.data" :key="gamification_reward.id">
                    <AppCard>
                        <div class="p-1 flex flex-col gap-1">
                            <div class="text-sm">
                                {{ gamification_reward.title }}
                            </div>
                            <div>
                                <ZoomableImage :src="gamification_reward.image_path">
                                    <img
                                        v-if="gamification_reward.image_path"
                                        :src="gamification_reward.image_path"
                                        alt=""
                                    />
                                </ZoomableImage>
                            </div>
                            <div>
                                <span class="text-xs text-gray-600">{{ gamification_reward.description }}</span>
                            </div>
                            <div>
                                <div v-if="gamification_reward.is_requestable">
                                    <AppButton
                                        :href="gamification_reward.links.request_create"
                                        v-if="gamification_reward.links.request_create"
                                    >
                                        {{ $t('messages.request') }}
                                    </AppButton>
                                    <Tippy v-else>
                                        <AppButton element="button" disabled>
                                            {{ $t('messages.request') }}
                                        </AppButton>

                                        <template #content>
                                            <div
                                                v-if="
                                                    gamification_reward.student_request_today_count ===
                                                    gamification_reward.max_request_per_day
                                                "
                                            >
                                                {{ $t('messages.max_request_per_day_reached') }}:
                                                {{ gamification_reward.max_request_per_day }}
                                            </div>
                                        </template>
                                    </Tippy>
                                </div>
                            </div>
                            <div>
                                <div class="flex space-x-1">
                                    <div>
                                        <BadgePill color="green" v-if="gamification_reward.experience_amount">
                                            {{ gamification_reward.experience_amount }}
                                        </BadgePill>
                                    </div>

                                    <div>
                                        <BadgePill color="yellow" v-if="gamification_reward.coins_amount">
                                            {{ gamification_reward.coins_amount }}
                                        </BadgePill>
                                    </div>

                                    <div>
                                        <BadgePill color="red" v-if="gamification_reward.health_amount">
                                            {{ gamification_reward.health_amount }}
                                        </BadgePill>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AppCard>
                </div>
            </div>
        </AppWell>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.title') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.description') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.points', 2) }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(gamification_reward, index) in rewards.data"
                                :key="gamification_reward.id"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div class="flex items-center space-x-3 lg:pl-2">
                                        <div
                                            :class="[gamification_reward.is_negative ? 'bg-red-500' : 'bg-indigo-500']"
                                            class="shrink-0 flex items-center justify-center h-6 w-6 md:w-28 md:h-28 rounded-lg p-1"
                                        >
                                            <ZoomableImage :src="gamification_reward.image_path">
                                                <img
                                                    v-if="gamification_reward.image_path"
                                                    :src="gamification_reward.image_path"
                                                    alt=""
                                                />
                                            </ZoomableImage>
                                        </div>
                                        <div>
                                            <div>
                                                {{ gamification_reward.title }}
                                            </div>
                                            <div v-if="gamification_reward.is_requestable">
                                                <AppButton
                                                    :href="gamification_reward.links.request_create"
                                                    v-if="gamification_reward.links.request_create"
                                                >
                                                    {{ $t('messages.request') }}
                                                </AppButton>
                                                <Tippy v-else>
                                                    <AppButton element="button" disabled>
                                                        {{ $t('messages.request') }}
                                                    </AppButton>

                                                    <template #content>
                                                        <div
                                                            v-if="
                                                                gamification_reward.student_request_today_count ===
                                                                gamification_reward.max_request_per_day
                                                            "
                                                        >
                                                            {{ $t('messages.max_request_per_day_reached') }}:
                                                            {{ gamification_reward.max_request_per_day }}
                                                        </div>
                                                    </template>
                                                </Tippy>
                                            </div>
                                            <div
                                                v-if="gamification_reward.pending_requests_count"
                                                class="text-gray-400"
                                            >
                                                <div>
                                                    {{ $t('messages.pending_requests') }}:
                                                    {{ gamification_reward.pending_requests_count }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="max-w-sm px-6 py-4 text-sm leading-5 font-medium text-gray-500">
                                    {{ gamification_reward.description }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div class="flex space-x-1">
                                        <div>
                                            <BadgePill color="green" v-if="gamification_reward.experience_amount">
                                                {{ gamification_reward.experience_amount }}
                                            </BadgePill>
                                        </div>

                                        <div>
                                            <BadgePill color="yellow" v-if="gamification_reward.coins_amount">
                                                {{ gamification_reward.coins_amount }}
                                            </BadgePill>
                                        </div>

                                        <div>
                                            <BadgePill color="red" v-if="gamification_reward.health_amount">
                                                {{ gamification_reward.health_amount }}
                                            </BadgePill>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="rewards" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import BadgePill from '@/components/BadgePill.vue';
import AppButton from '@/components/AppButton.vue';
import { Tippy } from 'vue-tippy';
import ZoomableImage from '@/components/ZoomableImage.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';

export default {
    components: {
        AppCard,
        AppWell,
        ZoomableImage,
        Tippy,
        AppButton,
        PanelPage,
        InertiaPagination,
        BadgePill,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'rewards'],
};
</script>
